import assignmentSettings from '@glass/rock/modules/payments/pricings/configs/data/assignments.data.json';

import { AssignmentSetting } from '@glass/common/modules/assignments/types';

export default assignmentSettings as AssignmentSetting[];
